import React from "react";
import PropTypes from "prop-types";
import { EditButton } from "MODULES/shared/components";
import { RETURN_TO } from "APP_ROOT/constants";
import ShippingAddress from "MODULES/Orders/shared/ShippingAddress";
import EditShipping from "./EditShipping";

export default class ReturnToShippingDetails extends React.Component {
  state = {
    editShippingModalOpen: false
  };

  openShippingModal = () => {
    this.setState({ editShippingModalOpen: true });
  };

  closeShippingModal = () => this.setState({ editShippingModalOpen: false });
  render() {
    const { managedRepairOrder, unlocked = true } = this.props;
    const { editShippingModalOpen } = this.state;

    return (
      <div>
        <h2>
          Return To Shipping
          {unlocked && <EditButton handleClick={this.openShippingModal} />}
          <EditShipping
            managedRepairOrder={managedRepairOrder.toJS()}
            open={editShippingModalOpen}
            close={this.closeShippingModal}
          />
        </h2>
        <ShippingAddress shippingType={RETURN_TO} record={managedRepairOrder} />
      </div>
    );
  }
}

ReturnToShippingDetails.propTypes = {
  managedRepairOrder: PropTypes.instanceOf(Object),
  unlocked: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/ReturnToShippingDetails/ReturnToShippingDetails.jsx